import { Form } from "antd";
import MenuFuncSelect from "./MenuFuncSelect";
import React, { useEffect, useContext, useMemo } from 'react';
import { FormMenuFuncSelectSettings } from './FormMenuFuncSelectSettings';

import { Resizer, FormContext } from 'wsc-react-custom-form';

const defaultProps = {
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  fillSpace: 'no',
  padding: ['0', '0', '0', '0'],
  margin: ['0', '0', '0', '0'],
  background: { r: 255, g: 255, b: 255, a: 1 },
  color: { r: 0, g: 0, b: 0, a: 1 },
  shadow: 0,
  radius: 0,
  width: '100%',
  height: 'auto',
};

export const FormMenuFuncSelect = (props) => {
  props = {
    ...defaultProps,
    ...props,
  };
  const {
    flexDirection,
    alignItems,
    justifyContent,
    fillSpace,
    background,
    color,
    padding,
    margin,
    shadow,
    radius,
    label,
    labelSpan,
    labelOffset,
    wrapperSpan,
    wrapperOffset,
    showLabel,
    name,
    rules,
    onlySelectFunctions, // 新增属性
  } = props;

  const { form, formdata } = useContext(FormContext);

  // name使用点号分割的：转换为数组
  const nameArray = useMemo(() => {
    const names = name.split('.');
    if (names.length === 1) {
      return names[0];
    } else {
      return names;
    }
  }, [name]);

  // 获取级联属性
  useEffect(() => {
    if (Array.isArray(nameArray)) {
      const value = nameArray.reduce((acc, item) => {
        if (acc?.hasOwnProperty(item)) {
          return acc[item];
        }
        return undefined;
      }, formdata);
      form.setFieldValue(nameArray, value);
    } else {
      form.setFieldValue(nameArray, formdata[name]);
    }
  }, [form, formdata, nameArray]);

  let noLabel = (showLabel == "false");
  return (
    <Resizer
      propKey={{ width: 'width', height: 'height' }}
      style={{
        justifyContent,
        flexDirection,
        alignItems,
        background: `rgba(${background.r}, ${background.g}, ${background.b}, ${background.a})})`,
        color: `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`,
        padding: `${padding[0]}px ${padding[1]}px ${padding[2]}px ${padding[3]}px`,
        margin: `${margin[0]}px ${margin[1]}px ${margin[2]}px ${margin[3]}px`,
        boxShadow:
          shadow === 0
            ? 'none'
            : `0px 3px 100px ${shadow}px rgba(0, 0, 0, 0.13)`,
        borderRadius: `${radius}px`,
        flex: fillSpace === 'yes' ? 1 : 'unset',
      }}
    >
      <Form.Item
        style={{ width: "100%" }}
        label={noLabel ? null : label}
        labelCol={{ span: labelSpan, offset: labelOffset }}
        wrapperCol={{ span: wrapperSpan, offset: wrapperOffset }}
        name={nameArray}
        rules={rules}
      >
        <MenuFuncSelect onlySelectFunctions={onlySelectFunctions} />
      </Form.Item>
    </Resizer>
  );
};

FormMenuFuncSelect.craft = {
  displayName: 'FormMenuFuncSelect',
  props: {
    name: "menuFuncs",
    label: "菜单功能",
    labelSpan: 6,
    labelOffset: 0,
    wrapperSpan: 18,
    wrapperOffset: 0,
    showLabel: "true",
    rules: [{ required: true, message: "菜单功能必须选择！" }],
    ...defaultProps,
    name: 'menuFuncSelect',
    label: '菜单功能选择',
    labelSpan: 6,
    labelOffset: 0,
    wrapperSpan: 18,
    wrapperOffset: 0,
    showLabel: 'true',
    disabled: 'false',
    rules: [],
    onlySelectFunctions: false, // 新增默认值
  },
  related: {
    toolbar: FormMenuFuncSelectSettings,
  },
};

FormMenuFuncSelect.Icon = () => {
  return (<span>FormMenuFuncSelect</span>);
};